<div
  *ngIf="{
    rating: aiChatRating$ | async,
    contentInfo: aiChatContentInfo$ | async
  } as data"
  class="rating-panel"
>
  <div class="rating">{{ data.rating.rating }}</div>

  <div class="rating-bar">
    <div class="fill" [style.width]="(ratingProgress$ | async) + '%'"></div>
  </div>

  <button class="photos-btn" (click)="openGallery()">
    <img src="/assets/img/chat-page/rating-bar/ai/photo.svg" alt="" />
    <span>
      <span class="current"> {{ data.contentInfo.unlockedContentCount }}</span>
      / {{ data.contentInfo.totalContentCount }}
    </span>
  </button>
</div>
